import { Component, input } from '@angular/core';

@Component({
  selector: 'im-input-error-message',
  templateUrl: './input-error-message.component.html',
  styleUrl: './input-error-message.component.scss',
})
export class InputErrorMessageComponent {
  errorMessage = input<string>();
}
